
import React from 'react';
import { Modal, Text, BlockStack, Card, Badge, Button, InlineStack } from '@shopify/polaris';
import { PlusIcon } from '@shopify/polaris-icons';

function IdeasModal({ open, onClose, ideas, isGenerating, onCreateArticle, generatingIndex }) {

  const typeColors = {
    'how-to': 'info',
    'listicle': 'success',
    'comparison': 'attention',
    'guide': 'info',
    'trend': 'warning'
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Content Ideas"
      primaryAction={{
        content: 'Close',
        onAction: onClose,
      }}
    >
      <Modal.Section>
        <BlockStack gap="400">
          {isGenerating ? (
            <Text>Generating ideas...</Text>
          ) : ideas && ideas.length > 0 ? (
            ideas.map((idea, index) => (
              <Card key={index}>
                <BlockStack gap="300">
                  <InlineStack align="space-between" blockAlign="start">
                    <InlineStack gap="200">
                      <Text variant="headingMd" as="h3">
                        {index + 1}. {idea.title}
                      </Text>
                      <Badge tone={typeColors[idea.type] || 'info'}>
                        {idea.type}
                      </Badge>
                    </InlineStack>
                  </InlineStack>
                  
                  <Text tone="subdued">{idea.reasoning}</Text>
                  
                  <InlineStack align="end">
                    <Button
                      variant="primary"
                      icon={PlusIcon}
                      onClick={() => onCreateArticle(idea, index)}
                      loading={generatingIndex === index}
                      disabled={generatingIndex !== null && generatingIndex !== index}
                    >
                      {generatingIndex === index ? 'Generating...' : 'Create Article'}
                    </Button>
                  </InlineStack>
                </BlockStack>
              </Card>
            ))
          ) : (
            <Text>No ideas generated yet.</Text>
          )}
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}

export default IdeasModal;
